import React, { useEffect } from "react";
import { object, string } from "prop-types";

import Anchor from "../Anchor";

import { fireVirtualPageOnSPA } from "../../../components/utils/utils";

import "./bigSectionName.m.css";

const BigSectionName = ({
  domainSlug,
  sectionsDataForHeader,
  domainSectionObj,
  src,
  customStyleName = "section-title",
  title,
}) => {
  if (!sectionsDataForHeader) {
    return null;
  }

  const getSectionData = () => {
    if (
      (domainSlug && sectionsDataForHeader.parentSectionId !== domainSectionObj.id) ||
      (sectionsDataForHeader.parentSection && !domainSlug)
    ) {
      return {
        sectionName: sectionsDataForHeader.parentSection,
        sectionUrl: sectionsDataForHeader.parentSectionUrl,
      };
    }

    return {
      sectionName: sectionsDataForHeader.currentSection,
      sectionUrl: sectionsDataForHeader.currentSectionUrl,
    };
  };

  let Htag = "h1";

  if (
    sectionsDataForHeader.currentSectionUrl &&
    sectionsDataForHeader.childSections.find(
      (item) =>
        String(sectionsDataForHeader.currentSectionUrl).toLowerCase() === String(item["section-url"]).toLowerCase()
    )
  ) {
    customStyleName = "small-section-title";
    Htag = "h2";
  }

  useEffect(() => {
    handleReload();
  }, [sectionsDataForHeader]);

  const handleReload = () => {
    if (document.readyState === "complete") {
      fireVirtualPageOnSPA(
        sectionsDataForHeader.parentSection !== null
          ? sectionsDataForHeader.parentSection.concat(",").concat(sectionsDataForHeader.currentSection)
          : sectionsDataForHeader.currentSection,
        "Not Applicable",
        sectionsDataForHeader.currentSectionUrl,
        title
      );
    }
  };

  return (
    <p className="section" styleName="section-name-container">
      <Anchor aria-label={getSectionData().sectionName} href={getSectionData().sectionUrl}>
        {src === "section" ? (
          <Htag styleName={customStyleName}>{getSectionData().sectionName}</Htag>
        ) : (
          getSectionData().sectionName
        )}
      </Anchor>
    </p>
  );
};

BigSectionName.propTypes = {
  domainSlug: string,
  domainSectionObj: object,
  sectionsDataForHeader: object,
  src: string,
  customStyleName: string,
  title: string,
};

export default BigSectionName;
